export const assessmentKitsConstants = {
  // create assessment Kit
  CREATE_ASSESSMENT_KIT_ACTION_REQUEST: "CREATE_ASSESSMENT_KIT_ACTION_REQUEST",
  CREATE_ASSESSMENT_KIT_ACTION_SUCCESS: "CREATE_ASSESSMENT_KIT_ACTION_SUCCESS",
  CREATE_ASSESSMENT_KIT_ACTION_FAILURE: "CREATE_ASSESSMENT_KIT_ACTION_FAILURE",

  // delete  assessment Kit
  DELETE_ASSESSMENT_KIT_ACTION_REQUEST: "DELETE_ASSESSMENT_KIT_ACTION_REQUEST",
  DELETE_ASSESSMENT_KIT_ACTION_SUCCESS: "DELETE_ASSESSMENT_KIT_ACTION_SUCCESS",
  DELETE_ASSESSMENT_KIT_ACTION_FAILURE: "DELETE_ASSESSMENT_KIT_ACTION_FAILURE",

  // MENTOR ALL ASSESSMENTs
  GET_ALL_ASSESSMENT_KIT_ACTION_REQUEST:
    "GET_ALL_ASSESSMENT_KIT_ACTION_REQUEST",
  GET_ALL_ASSESSMENT_KIT_ACTION_SUCCESS:
    "GET_ALL_ASSESSMENT_KIT_ACTION_SUCCESS",
  GET_ALL_ASSESSMENT_KIT_ACTION_FAILURE:
    "GET_ALL_ASSESSMENT_KIT_ACTION_FAILURE",

  //ASSESSMENT Kit by id
  GET_ASSESSMENT_KIT_BY_ID_ACTION_REQUEST:
    "GET_ASSESSMENT_KIT_BY_ID_ACTION_REQUEST",
  GET_ASSESSMENT_KIT_BY_ID_ACTION_SUCCESS:
    "GET_ASSESSMENT_KIT_BY_ID_ACTION_SUCCESS",
  GET_ASSESSMENT_KIT_BY_ID_ACTION_FAILURE:
    "GET_ASSESSMENT_KIT_BY_ID_ACTION_FAILURE",

  //update ASSESSMENT kit topic
  UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_REQUEST:
    "UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_REQUEST",
  UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_SUCCESS:
    "UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_SUCCESS",
  UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_FAILURE:
    "UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_FAILURE",

  //get candidate list of assessment kit topic
  GET_ASSESSMENT_KITS_CANDIDATES_ACTION_REQUEST:
    "GET_ASSESSMENT_KITS_CANDIDATES_ACTION_REQUEST",
  GET_ASSESSMENT_KITS_CANDIDATES_ACTION_SUCCESS:
    "GET_ASSESSMENT_KITS_CANDIDATES_ACTION_SUCCESS",
  GET_ASSESSMENT_KITS_CANDIDATES_ACTION_FAILURE:
    "GET_ASSESSMENT_KITS_CANDIDATES_ACTION_FAILURE",

  //assign assessment kit to candidate topic
  ASSIGN_ASSESSMENT_KITS_TO_CANDIDATE_ACTION_REQUEST:
    "ASSIGN_ASSESSMENT_KITS_TO_CANDIDATE_ACTION_REQUEST",
  ASSIGN_ASSESSMENT_KITS_TO_CANDIDATE_ACTION_SUCCESS:
    "ASSIGN_ASSESSMENT_KITS_TO_CANDIDATE_ACTION_SUCCESS",
  ASSIGN_ASSESSMENT_KITS_TO_CANDIDATE_ACTION_FAILURE:
    "ASSIGN_ASSESSMENT_KITS_TO_CANDIDATE_ACTION_FAILURE",

  // create assessment kit skills
  CREATE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST:
    "CREATE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST",
  CREATE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS:
    "CREATE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS",
  CREATE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE:
    "CREATE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE",

  // delete assessment kit skills
  DELETE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST:
    "DELETE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST",
  DELETE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS:
    "DELETE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS",
  DELETE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE:
    "DELETE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE",

  // update assessment kit skills
  UPDATE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST:
    "UPDATE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST",
  UPDATE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS:
    "UPDATE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS",
  UPDATE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE:
    "UPDATE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE",

  //view candidate assement resonse
  VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_REQUEST:
    "VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_REQUEST",
  VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_SUCCESS:
    "VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_SUCCESS",
  VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_FAILURE:
    "VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_FAILURE",

  //get candidate assigned assessment details
  GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_REQUEST:
    "GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_REQUEST",
  GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_SUCCESS:
    "GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_SUCCESS",
  GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_FAILURE:
    "GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_FAILURE",

  //accept assessment kit
  ACCEPT_ASSESSMENT_KIT_REVIEW_ACTION_REQUEST:
    "ACCEPT_ASSESSMENT_KIT_REVIEW_ACTION_REQUEST",
  ACCEPT_ASSESSMENT_KIT_REVIEW_ACTION_SUCCESS:
    "ACCEPT_ASSESSMENT_KIT_REVIEW_ACTION_SUCCESS",
  ACCEPT_ASSESSMENT_KIT_REVIEW_ACTION_FAILURE:
    "ACCEPT_ASSESSMENT_KIT_REVIEW_ACTION_FAILURE",

  SHORTLIST_CANDIDATE_ASSESSMENT_KIT_ACTION_REQUEST:
    "SHORTLIST_CANDIDATE_ASSESSMENT_KIT_ACTION_REQUEST",
  SHORTLIST_CANDIDATE_ASSESSMENT_KIT_ACTION_SUCCESS:
    "SHORTLIST_CANDIDATE_ASSESSMENT_KIT_ACTION_SUCCESS",
  SHORTLIST_CANDIDATE_ASSESSMENT_KIT_ACTION_FAILURE:
    "SHORTLIST_CANDIDATE_ASSESSMENT_KIT_ACTION_FAILURE",

  REJECT_CANDIDATE_ASSESSMENT_KIT_ACTION_REQUEST:
    "REJECT_CANDIDATE_ASSESSMENT_KIT_ACTION_REQUEST",
  REJECT_CANDIDATE_ASSESSMENT_KIT_ACTION_SUCCESS:
    "REJECT_CANDIDATE_ASSESSMENT_KIT_ACTION_SUCCESS",
  REJECT_CANDIDATE_ASSESSMENT_KIT_ACTION_FAILURE:
    "REJECT_CANDIDATE_ASSESSMENT_KIT_ACTION_FAILURE",

  // create assessment kit remark
  ASSESSMENT_KIT_REVIEWEE_REMARK_ACTION_REQUEST:
    "ASSESSMENT_KIT_REVIEWEE_REMARK_ACTION_REQUEST",
  ASSESSMENT_KIT_REVIEWEE_REMARK_ACTION_SUCCESS:
    "ASSESSMENT_KIT_REVIEWEE_REMARK_ACTION_SUCCESS",
  ASSESSMENT_KIT_REVIEWEE_REMARK_ACTION_FAILURE:
    "ASSESSMENT_KIT_REVIEWEE_REMARK_ACTION_FAILURE",

  CREATE_CANDIDATE_RESPONSE_RATING_ACTION_REQUEST:
    "CREATE_CANDIDATE_RESPONSE_RATING_ACTION_REQUEST",
  CREATE_CANDIDATE_RESPONSE_RATING_ACTION_SUCCESS:
    "CREATE_CANDIDATE_RESPONSE_RATING_ACTION_SUCCESS",
  CREATE_CANDIDATE_RESPONSE_RATING_ACTION_FAILURE:
    "CREATE_CANDIDATE_RESPONSE_RATING_ACTION_FAILURE",

  UPDATE_CANDIDATE_RESPONSE_RATING_ACTION_REQUEST:
    "UPDATE_CANDIDATE_RESPONSE_RATING_ACTION_REQUEST",
  UPDATE_CANDIDATE_RESPONSE_RATING_ACTION_SUCCESS:
    "UPDATE_CANDIDATE_RESPONSE_RATING_ACTION_SUCCESS",
  UPDATE_CANDIDATE_RESPONSE_RATING_ACTION_FAILURE:
    "UPDATE_CANDIDATE_RESPONSE_RATING_ACTION_FAILURE",

  //get candidate assigned assessment details
  GET_SKILL_TOPICS_DETAILS_ACTION_REQUEST:
    "GET_SKILL_TOPICS_DETAILS_ACTION_REQUEST",
  GET_SKILL_TOPICS_DETAILS_ACTION_SUCCESS:
    "GET_SKILL_TOPICS_DETAILS_ACTION_SUCCESS",
  GET_SKILL_TOPICS_DETAILS_ACTION_FAILURE:
    "GET_SKILL_TOPICS_DETAILS_ACTION_FAILURE",

  // create custom question
  CREATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_REQUEST:
    "CREATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_REQUEST",
  CREATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_SUCCESS:
    "CREATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_SUCCESS",
  CREATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_FAILURE:
    "CREATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_FAILURE",

  // MENTOR ALL ASSESSMENTs
  GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_REQUEST:
    "GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_REQUEST",
  GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_SUCCESS:
    "GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_SUCCESS",
  GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_FAILURE:
    "GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_FAILURE",

  // delete  assessment Kit
  DELETE_ASSESSMENT_CUSTOM_QUESTION_ACTION_REQUEST:
    "DELETE_ASSESSMENT_CUSTOM_QUESTION_ACTION_REQUEST",
  DELETE_ASSESSMENT_CUSTOM_QUESTION_ACTION_SUCCESS:
    "DELETE_ASSESSMENT_CUSTOM_QUESTION_ACTION_SUCCESS",
  DELETE_ASSESSMENT_CUSTOM_QUESTION_ACTION_FAILURE:
    "DELETE_ASSESSMENT_CUSTOM_QUESTION_ACTION_FAILURE",

  //upda0e ASSESSMENT custom question
  UPDATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_REQUEST:
    "UPDATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_REQUEST",
  UPDATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_SUCCESS:
    "UPDATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_SUCCESS",
  UPDATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_FAILURE:
    "UPDATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_FAILURE",

  // MENTOR ALL ASSESSMENTs
  GET_CANDIDATE_ASSESSMENT_ACTION_REQUEST:
    "GET_CANDIDATE_ASSESSMENT_ACTION_REQUEST",
  GET_CANDIDATE_ASSESSMENT_ACTION_SUCCESS:
    "GET_CANDIDATE_ASSESSMENT_ACTION_SUCCESS",
  GET_CANDIDATE_ASSESSMENT_ACTION_FAILURE:
    "GET_CANDIDATE_ASSESSMENT_ACTION_FAILURE",
};
